"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubstringMatchType = exports.GroupType = void 0;
/**
 * Represents the type of the Intent.
 */
var GroupType;
(function (GroupType) {
    GroupType["IntentText"] = "IntentText";
    GroupType["IntentEntity"] = "IntentEntity";
    GroupType["Generic"] = "Generic";
    GroupType["People"] = "People";
    GroupType["Place"] = "Place";
    GroupType["DynamicEntity"] = "DynamicEntity";
})(GroupType = exports.GroupType || (exports.GroupType = {}));
/**
 * Represents the type of the substring match.
 */
var SubstringMatchType;
(function (SubstringMatchType) {
    SubstringMatchType["None"] = "None";
    SubstringMatchType["LeftRooted"] = "LeftRooted";
    SubstringMatchType["PartialName"] = "PartialName";
    SubstringMatchType["MiddleOfSentence"] = "MiddleOfSentence";
})(SubstringMatchType = exports.SubstringMatchType || (exports.SubstringMatchType = {}));

//# sourceMappingURL=Group.js.map
